export default __webpack_public_path__ + "images/c5abfab20f1a9923b17ee3b06a05aefc-inv-exp-icon.svg";